import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadApproversByRecord } from 'store/approvals/thunks/loadApproversByRecord';
import { loadAssignmentsForProject } from 'store/assignments/thunks/loadAssignmentsForProject';
import { loadEmployerAllowancesByBusinessId } from 'store/employerAllowances/thunks/loadEmployerAllowancesByBusinessId.thunk';
import { selectIsShadowProject } from 'store/projects/selectors/projectsSelectors';
import { selectCurrentUserEmployerProjects } from 'store/resources/selectors/resources.selectors';
import { loadResourcesAndResourceEmployersOfProject } from 'store/resources/thunks/loadResourcesAndResourceEmployersOfProject';
import { loadShadowRecordForRecord } from 'store/shadowData/thunks/loadShadowRecordForRecord.thunk';
import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import { selectRecord } from '../actions/records.actions';
import { selectSelectedRecord } from '../selectors/records.selectors';
import { getRecordsBreakRecords } from './getRecordsBreakRecords.thunk';

export const openEditRecordDialog = createAsyncThunk(
  'records/openEditRecordDialog',
  async (recordId, { dispatch, getState, rejectWithValue }) => {
    dispatch(selectRecord(recordId));

    const userEmployers = selectCurrentUserEmployerProjects(getState());

    const employerBusinessIds = userEmployers.map(
      (employerProject) => employerProject.business_id
    );

    let record = selectSelectedRecord(getState());

    if (!record) {
      rejectWithValue('record_not_found');
    }

    if (!record.billedClockInAt) {
      record = {
        ...record,
        billedClockInAt: record.clockInAt,
      };
    }
    if (!record.billedClockOutAt) {
      record = {
        ...record,
        billedClockOutAt: record.clockOutAt,
      };
    }

    const editableAttributes = {
      billedClockInAt: record.billedClockInAt,
      billedClockOutAt: record.billedClockOutAt,
      clockInAt: record.clockInAt,
      clockOutAt: record.clockOutAt,
      status: record.status,
      project: record.project,
      description: record.description,
      id: record.id,
      assignment: record.assignment,
      resource: record.resource,
      type: record.type,
      latIn: record.latIn,
      latOut: record.latOut,
      longIn: record.longIn,
      longOut: record.longOut,
      assignmentUnitAmount: record.assignmentUnitAmount,
      subType: record.subType,
    };

    dispatch(loadResourcesAndResourceEmployersOfProject(record.project));
    dispatch(loadAssignmentsForProject(record.project));
    const isShadowProject = selectIsShadowProject(record.project)(getState());
    if (isShadowProject) {
      dispatch(loadShadowRecordForRecord(record.id));
      const activeEmployerBusinessId =
        selectUserActiveEmployerBusinessId(getState());
      const shadowProjectId = `${record.project}_${activeEmployerBusinessId}`;
      dispatch(loadAssignmentsForProject(shadowProjectId));
    }
    dispatch(loadApproversByRecord(record.id));
    dispatch(
      getRecordsBreakRecords({
        projectId: record.project,
        parentRecordId: record.id,
      })
    );

    if (employerBusinessIds && employerBusinessIds.length > 0) {
      employerBusinessIds.map((businessId) =>
        dispatch(loadEmployerAllowancesByBusinessId(businessId))
      );
    }

    return editableAttributes;
  }
);
